// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { cartDiscountPercentDisplayStyles } from "@guestsupply/App/Components/Cart/CartDiscountPercentDisplay";
import cartSummarySharedStyles from "@guestsupply/App/SharedStyles/CartSummarySharedStyles";
import { css } from "styled-components";

cartDiscountPercentDisplayStyles.container = {
    ...cartSummarySharedStyles.container,
};
cartDiscountPercentDisplayStyles.labelGridItem = { ...cartSummarySharedStyles.labelGridItem };
cartDiscountPercentDisplayStyles.valueGridItem = { ...cartSummarySharedStyles.valueGridItem };
cartDiscountPercentDisplayStyles.subtotalValue = {
    ...cartSummarySharedStyles.valueText,
};
cartDiscountPercentDisplayStyles.subtotalLabel = {
    ...cartSummarySharedStyles.labelText,
};
cartDiscountPercentDisplayStyles.wrapper = {
    css: css`
        &:empty {
            display: none;
        }
    `,
};
